import { ChainIdEnum } from 'config/constants/network'
import { Token } from 'config/types'
import { useState } from 'react'
import { useListTokens } from 'state/app/hooks'
import { PAYMENT_MODAL_THEME } from 'views/Payment/MobilePayment/components/styles'
import { DepositFiatControls, DepositModeEnums, useDepositControl } from 'views/Payment/MobilePayment/hooks/useDeposit'
import { useWaitingDepositToActiveBonus } from 'views/Payment/components/Deposit/DepositCryptos/hooks'

import { ModalBody, ModalHeader } from 'UIKit/AlchemyModal'
import OpenEffect from 'UIKit/OpenEffect'
import { DepositFiatPaymentMethod } from 'config/types/payment'
import Column from 'layout/Components/Column'
import { useTranslation } from 'react-i18next'
import { usePaymentSelectedFiatCurrency } from 'state/session/hooks'
import { isFiatNetwork } from 'utils/network'
import { PaymentPageEnums } from 'views/Payment/Menu'
import DepositFiatForm from 'views/Payment/MobilePayment/Deposit/DepositFiat/DepositFiatForm'
import PaymentBankCurrency from '../../components/PaymentBankCurrency'

import { ContentBankSelect } from '../../components/BankSelectDropdown'

const DepositFiat: React.FC<{ selectedTokenInit: Token; onBack: () => void }> = ({ selectedTokenInit, onBack }) => {
  const { t } = useTranslation()
  const [isShowBankSelect, setIsShowBankSelect] = useState(false)

  const userDefaultSelectCurrency = usePaymentSelectedFiatCurrency()
  const [selectedToken, setSelectCurrency] = useState<Token>(
    isFiatNetwork(selectedTokenInit.network) ? selectedTokenInit : userDefaultSelectCurrency || undefined,
  )
  const bonusControl = useWaitingDepositToActiveBonus()

  const currencies = useListTokens(ChainIdEnum.FIAT)
  const { depositControl } = useDepositControl<DepositFiatControls>({
    selectedToken,
    mode: DepositModeEnums.FIAT,
  })

  if (isShowBankSelect) {
    return (
      <>
        <ModalHeader
          onBack={() => setIsShowBankSelect(false)}
          useBackIcon
          hideStroke
          titleAlign="left"
          colorTheme={PAYMENT_MODAL_THEME}
          title={t('Select Method')}
        />
        <ModalBody>
          <OpenEffect openType="grow" duration={0.4}>
            <Column gap="var(--pm-space-component)" height="100%">
              <ContentBankSelect<DepositFiatPaymentMethod>
                maxHeight="100%"
                onSelect={(bank) => {
                  depositControl.handler.onSelectMethod(bank)
                  setIsShowBankSelect(false)
                }}
                selectedMethod={depositControl.data.selectedPaymentMethod}
                optionBanks={depositControl.data.paymentMethods}
              />
            </Column>
          </OpenEffect>
        </ModalBody>
      </>
    )
  }

  return (
    <>
      <ModalHeader
        hideStroke
        titleAlign="left"
        colorTheme={PAYMENT_MODAL_THEME}
        title="Deposit Fiat"
        useBackIcon
        onBack={onBack}
      />
      <ModalBody overflow="scroll">
        <OpenEffect openType="grow" duration={0.4}>
          <Column gap="var(--pm-space-component)" height="100%">
            <PaymentBankCurrency
              onPresentMethodSelect={() => {
                setIsShowBankSelect(true)
              }}
              currencies={currencies}
              selectedPaymentMethod={depositControl.data.selectedPaymentMethod}
              selectedCurrency={selectedToken}
              onCurrencySelect={setSelectCurrency}
              from={PaymentPageEnums.Deposit}
            />
            <DepositFiatForm
              selectedToken={selectedToken}
              bonusControl={bonusControl}
              depositControl={depositControl}
            />
          </Column>
        </OpenEffect>
      </ModalBody>
    </>
  )
}

export default DepositFiat
